export class DocumentModel {
  documentType: number;
  description: string;
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/document.model.ts